/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-13 15:42:40
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-04 19:17:36
 * @FilePath: \baishu_react_ui\src\components\BsyDataManager\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { withRouter } from "react-router-dom";
import { BsyUtils } from "../../utils/Utils";
import BsyAddressbook from "../BsyAddressbook";
import BsyDataManage from "../BsyDataManage";
import BsyMsgBubble from "../BsyMsgBubble";
import BsySlidePane from "../BsySlidePane";
import BsySLoading from "../BsySLoading";

import { BsyWidget } from "../BsyWidget";

import "./index.css";
import BsySystemRightMenu from "../BsySystemRightMenu";
import BsySystemLeftMenu from "../BsySystemLeftMenu";
import { setPageTitle } from "../../utils/setPageTitle";

class BsyDataManagePage extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-data-manage-page",
    entryname: "",
    appName: "",
    ptlist: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      appId: props.appid || props.match.params.appid || window.FX.STATIC.APPID,
      formId: props.match.params.entryid || window.FX.STATIC.ENTRYID,
      // entryname: entryname,
      // appname: appName
      ...props,
    };

    this.element = React.createRef();
  }

  componentDidMount() {
    this._getMsgUnread();
    this._getPrintQr();
    this.loadForm();
  }

  loadPrintList = (cb) => {
    ///dashboard/app/5a95b19cb8b854d6ee3650a2/form/5b35fd13366d459868896666/pt/list
    const { appId, formId } = this.state;
    React.axios(`/dashboard/app/${appId}/form/${formId}/pt/list`, {
      limit: 500,
      skip: 0,
    })
      .then((res) => {
        let ptlist = [
          {
            name: React.language("data.printTemplate.system"),
            printId: "system",
          },
        ];

        for (let i = 0; i < res.data.templates.length; i++) {
          ptlist.push({
            ...res.data.templates[i],
          });
        }
        cb && cb(ptlist);
      })
      .catch((res) => {
        console.error(res);
        cb &&
          cb([
            {
              name: React.language("data.printTemplate.system"),
              printId: "system",
            },
          ]);
      });
  };

  loadForm = () => {
    const { appId, formId } = this.state;

    this.setState({ isLoading: true });

    React.axios(
      `/dashboard/app/${appId}/form/${formId}/edit`,
      { appId: appId },
      { cancelTokenTs: this.cancelTokenTs }
    )
      .then((res) => {
        const h = res ? res.data : {};
        window.FX.STATIC.entryConfig = h; //数据管理 导入数据的时候 功能模块使用
        window.FX.STATIC.entryConfig.appType = h.appType;
        setPageTitle( h.name + " - " + React.language("form.data"));
        const t = h.type;
        window.FX.STATIC.appId = appId;
        window.FX.STATIC.entryId = formId;
        window.FX.STATIC.APPID = appId;
        window.FX.STATIC.ENTRYID = formId;
        window.FX.STATIC.INNERLINK = h._id;
        window.FX.STATIC.notice_setting = window.$.extend(
          {},
          h.attr.notice_setting
        );
        window.FX.Utils._entryMapgg();

        this.loadPrintList((ptlist) => {
          this.setState({
            appType: h.appType,
            isLoading: false,
            entryname: h.name,
            type: t,
            showContentEmpty: true,
            page: 0,
            appId: appId,
            entryId: formId,
            authGroupMap: {},
            authGroupId: null,
            ptlist: ptlist,
            // titleName: this.props.entryMap[entryId].name + " - " + this.props.appName,
            formConfig: {
              ...h,
              appId: h.appId,
              entryId: h.entryId,
            },
          });
        });
      })
      .catch((res) => {
        console.error(res);
        this.setState({ isLoading: false });
      });
  };

  visitFrom = () => {
    const { entryId, appId } = this.state;
    this.props.history.push({
      pathname: `${window.rootDirectroy}/team/app/${appId}/form/${entryId}`,
    });
  };

  renderDataTable = () => {
    const { formConfig, entryId, appId, authGroupId, ptlist, appType } =
      this.state;

    if (!formConfig) {
      return "";
    }

    let f = {};
    let showFields = [];
    window.$.map(f.optAuth, function (v, k) {
      if (v.visible) showFields.push(k);
    });
    let g = window.FX.Store.getKey("paramFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    var h = window.FX.Store.getKey("showFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    var i = window.FX.Store.getKey("metaFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    window.FX.STATIC.DECISION_SWITCH =
      formConfig.attr.flow &&
      formConfig.attr.flow.decision &&
      formConfig.attr.flow.decision.switch
        ? formConfig.attr.flow.decision.switch
        : false;
    window.FX.STATIC.PublicData = formConfig.attr.PublicData;
    let config = {
      appType: appType,
      appId: formConfig.appId,
      entryId: formConfig.entryId,
      formName: formConfig.name,
      formTabs: formConfig.formTabs,
      formTabsStyle: formConfig.formTabsStyle || {},
      formItems: formConfig.content.items,
      submitAttr: formConfig.content.submitAttr,
      data_cache: formConfig.content.data_cache,
      initializeModuleEvent: formConfig.content.initializeModuleEvent,
      initializeDataExtendSet: formConfig.content.initializeDataExtendSet,
      formAttr: {
        submitRule: formConfig.content.submitRule,
        layout: formConfig.content.layout,
        validators: formConfig.content.validators,
        confirmSettings: formConfig.content.confirmSettings,
        fieldShowRules: formConfig.content.fieldShowRules,
        subformFieldShowRules: formConfig.content.subformFieldShowRules,
      },
      originPrint: "manage",
      ignoreOptAuth: true,
      ignoreValidate: true,
      ignoreAuth: true,
      hasDataRecycle: true,
      hasExtParams: formConfig.attr.hasExtParams,
      hasUserSource: formConfig.attr.hasUserSource === true,
      hasFlow: formConfig.attr.hasFlow,
      hasCoop: formConfig.attr.hasCoop,
      flow: formConfig.attr.flow,
      enableRowEdit: formConfig.attr.enableRowEdit,
      quickEdit: formConfig.attr.quickEdit,

      // dataPerms: f.dataPerms,
      // optAuth: f.optAuth,
      ptlist: ptlist,
      authGroupId: authGroupId,
      showFieldsFilter: window.FX.Store.get(g),
      showFields: window.FX.Store.get(h),
      showFieldsMeta: window.FX.Store.get(i),
      printId: f.printId,
    };

    return <BsyDataManage {...config} />;
  };

  _getMsgUnread = (cb) => {
    let b = this;
    window.FX.Utils.ajax(
      {
        url: "/message/unread",
      },
      function (d) {
        b.setState(
          {
            haveNews: d.count > 0,
            noticeinfo: d.noticeinfo,
          },
          () => {
            b.noticeinfo = d.noticeinfo;
            b.createUpDateTip(d);
            cb && cb(d);
          }
        );
      }
    );
  };

  _getPrintQr = (cb) => {
    const { appId, formId } = this.state;
    let b = this;
    window.FX.Utils.ajax(
      {
        url: "/dashboard/app/" + appId + "/form/" + formId + "/printqr",
      },
      function (d) {
        window.FX.STATIC.PRINTQR = { ...d };
      }
    );
  };

  createUpDateTip = (c) => {
    let noticeinfo = c ? c.noticeinfo : this.state.noticeinfo;
    if (
      BsyUtils.isObjectEmpty(noticeinfo) ||
      window.$(".bsy-update-tip").length > 0
    ) {
      return;
    }
    let updateTip = window
      .$("<div class='bsy-update-tip' />")
      .css({ "z-index": window.FX.STATIC.zIndex++ })
      .appendTo(window.$("body"));
    let strKey = "bbynotice_" + noticeinfo.cookie_str;
    window
      .$("<div class='update-title' />")
      .append(window.$("<span />").text(noticeinfo.title))
      .append(
        window.$("<i class='icon icon-bsy-close' />").on("click", function () {
          const closeTime = Math.ceil(new Date().getTime() / 1000);
          const endTime = noticeinfo.endtime - closeTime;
          updateTip.animate({ right: -updateTip.width() + "px" }, 0);
          setTimeout(function () {
            updateTip.remove();
          }, 500);
          endTime > 0 &&
            window.FX.Cookie.set(strKey, closeTime, {
              expires: new Date(noticeinfo.endtime * 1000),
              path: "/",
            });
        })
      )
      .appendTo(updateTip);
    window
      .$("<div class='update-cont' />")
      .append(window.$("<span />").text(noticeinfo.content))
      .appendTo(updateTip);
    window
      .$("<div class='update-btn' />")
      .append(
        window
          .$("<a />")
          .on("click", function () {
            const closeTime = Math.ceil(new Date().getTime() / 1000);
            const endTime = noticeinfo.endtime - closeTime;
            window.FX.Utils.redirectTo(noticeinfo.link, "_blank");
            endTime > 0 &&
              window.FX.Cookie.set(strKey, closeTime, {
                expires: new Date(noticeinfo.endtime * 1000),
                path: "/",
              });
          })
          .text(React.language("view.detail"))
      )
      .appendTo(updateTip);
  };

  userMananger = () => {
    window.location.href =
      "/corp/addressbook?referer_uri=" + window.location.href;
    // BsySlidePane({
    //   title: React.language('contacts'),
    //   hasHeader: false,
    //   onContentCreate: (ref) => {
    //     return <BsyAddressbook alertDom={ref} />
    //   },
    // })
  };

  openMessage = (event) => {
    const _this = this;
    new window.FX.Slider({
      title: React.language("message.center"),
      contentWidget: {
        type: "messagecenter",
      },
      onClose: function () {
        _this._getMsgUnread(function (e) {
          if (e.count > 0) {
            _this.setState({ haveNews: true });
          } else {
            _this.setState({ haveNews: false });
          }
        });
      },
    }).show();
  };

  exprotOpen = () => {
    new window.FX.Slider({
      title: React.language("export.management"),
      contentWidget: {
        type: "formexportpane",
      },
      onClose: function () {
        clearTimeout(window.eventid);
      },
    }).show();
  };

  openBrowser = () => {
    var url = window.location.href;
    window.FX.Utils.dataAjax(
      {
        url: "/sso/getJumpUrl",
        data: {
          url: url,
        },
      },
      function (data) {
        if (window.wx) {
          window.wx.invoke(
            "openDefaultBrowser",
            {
              url: data.url, // 在默认浏览器打开redirect_uri，并附加code参数；也可以直接指定要打开的url，此时不会附带上code参数。
            },
            function (res) {
              if (res.err_msg != "openDefaultBrowser:ok") {
                //错误处理
              }
            }
          );
        } else {
          window.open(data.url);
        }
      },
      null
    );
  };

  toFormDesign = () => {
    const { formId, appId, entryname, appName } = this.state;
    // this.props.history.push({ pathname: `/team/app/${appId}/form/${formId}/datamanage`,   })
    window.location.href = `${window.rootDirectroy}/dashboard/app/${appId}/form/${formId}/edit#/`;
  };

  render() {
    const { entryname, isLoading, appId, formId } = this.state;
    const { cssName } = this.options;
    const nickname = window.FX.STATIC.user.nickname;
    const bg = BsyUtils.formatUserThumb(nickname);
    return (
      <div className={cssName} ref={this.element}>
        {!BsyUtils.isCorpOwn() &&
        !BsyUtils.isSysManager() &&
        !BsyUtils.isSubAdmin() ? (
          <div className={"page-error"}>{"没有权限"}</div>
        ) : (
          <div className={"page-content"}>
            <div className={"page-menu"}>
              {
                <BsySystemLeftMenu
                  homeIcon={() => {
                    return <i className="icon-bsy-left"></i>;
                  }}
                  homeLink={"/team/app/" + appId + "/form/" + formId}
                  // backTitle={React.language("standard.application")}
                  onRenderTitle={() => (
                    <div
                      className="left-title"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {entryname
                        ? entryname + " - " + React.language("form.data")
                        : ''}
                    </div>
                  )}
                />
              }

              <div className={"right-menu"}>
                {
                  // <div className={'visit-form'} onClick={this.visitFrom}>{React.language('app.access')}</div>
                }
                {
                  <div
                    className="edit-form"
                    style={{
                      left: "auto",
                      right: "122px",
                    }}
                    onClick={this.toFormDesign}
                  >
                    <i class="icon icon-bsy-reportmenu-1"></i>
                    <span>{React.language("edit.form")}</span>
                  </div>
                }

                <BsySystemRightMenu />
              </div>
            </div>
            <div className={"page-body"}>
              {this.renderDataTable()}
              {isLoading && <BsySLoading mode={"skeletonspin"} />}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(BsyDataManagePage);
